/* Shared transport. Callers own their abort controller and generation guard. */
(function () {
  if (window.DrhRecommendations) return;
  window.DrhRecommendations = {
    async request({ endpoint, productId, sectionId, limit = 10, intent = 'related', signal }) {
      const url = new URL(endpoint, window.location.origin);
      url.searchParams.set('product_id', productId);
      url.searchParams.set('section_id', sectionId);
      url.searchParams.set('limit', String(Math.min(10, Math.max(1, Number(limit) || 10))));
      url.searchParams.set('intent', intent);
      const response = await window.fetch(`${url.pathname}${url.search}`, { signal });
      if (!response.ok) throw new Error(`HTTP ${response.status}`);
      return response.text();
    },
  };
})();
